import { useNavigate } from "@tanstack/react-router";
import { accionesDisponiblesPara } from "../data/quick-actions";
import { QuickAction } from "./QuickAction";

/**
 * Card del panel de acciones rápidas (diseño de referencia) · filtra el
 * catálogo declarativo contra los roles del usuario y apila las acciones. El
 * botón de cada fila lleva el título completo de la acción.
 */
export function AccionesRapidasCard({
  roles,
  permisos,
}: {
  roles: ReadonlyArray<string>;
  permisos: ReadonlyArray<string>;
}) {
  const navigate = useNavigate();
  const disponibles = accionesDisponiblesPara(permisos, roles);

  return (
    <div className="flex h-full flex-col rounded-2xl border border-slate-200/80 bg-slate-100/60 p-4 shadow-2xs dark:border-ink-700 dark:bg-ink-800/40">
      <div className="mb-3 flex items-center justify-between">
        <div>
          <h3 className="text-xs font-bold uppercase tracking-wide text-foreground">Acciones rápidas</h3>
          <p className="text-[11px] text-muted-foreground">Las disponibles según tus permisos</p>
        </div>
        <span className="rounded-md bg-muted px-2 py-0.5 text-[10px] font-bold uppercase text-muted-foreground">
          {roles.length} rol{roles.length === 1 ? "" : "es"}
        </span>
      </div>

      <div className="space-y-2.5">
        {disponibles.map(({ action, titulo }) => (
          <QuickAction
            key={action.id}
            icon={action.icon}
            title={titulo}
            description={action.description}
            accent={action.accent}
            // El botón muestra el `cta` de la acción (uniforme "Nueva solicitud"
            // en las 3 de creación) o el título si no lo declara. Cuando el
            // botón es genérico, el aria-label lo desambigua con el título para
            // que un lector de pantalla no oiga 3 botones idénticos.
            cta={action.cta ?? titulo}
            ariaLabel={action.cta ? `${action.cta}: ${titulo}` : titulo}
            onClick={() => void navigate({ to: action.to as never, search: (action.search ?? {}) as never })}
          />
        ))}
      </div>
    </div>
  );
}
